// extracted by css-extract-rspack-plugin
export default {"pillsRow":"UI0TK","max":"jkreC","dragOver":"GoDFv","pill":"EsR1_","dragging":"rP1pZ","inputField":"nXUsb"};